export interface CategoryGroup {
    Id: number;
    Name: string;
    Icon: string;
    TenderIcon: string;
}

export class CreateCategoryGroup {
    id: number;
    name: string;
    icon: string;
    tenderIcon: string;
}

export class EditCategoryGroup extends CreateCategoryGroup {
    id: number;
    constructor (item?: CategoryGroup) {
        super();
        this.id = item && item.Id;
        this.name = item && item.Name;
        this.icon = item && item.Icon;
        this.tenderIcon = item && item.TenderIcon;
    }
}


// WEBPACK FOOTER //
// ./src/app/models/inModels/CategoryGroup.ts